import { createFileRoute } from "@tanstack/react-router";
import {
  getPointQueryOptions,
  liveChannelsQueryOptions,
} from "~/features/live/api";
import { LiveBroadcasterProfileTemplate } from "~/features/live/LiveBroadcasterProfileTemplate";
import {
  publicImagesQueryOptions,
  userProfileQueryOptions,
} from "~/features/profile/api";
import { UserProfileSkeleton } from "~/features/profile/components/UserProfileSkeleton";

const LiveBroadcasterProfilePage = () => {
  const { userId } = Route.useParams();
  return <LiveBroadcasterProfileTemplate userId={userId} />;
};

export const Route = createFileRoute(
  "/_authenticated/profile/live-broadcaster/$userId",
)({
  loader: async ({ context: { queryClient }, params: { userId } }) => {
    await Promise.all([
      queryClient.ensureQueryData(userProfileQueryOptions(userId)),
      queryClient.ensureQueryData(publicImagesQueryOptions(userId)),
      queryClient.ensureQueryData(liveChannelsQueryOptions()),
      queryClient.ensureQueryData(getPointQueryOptions()),
    ]);
  },
  pendingMs: 200,
  pendingMinMs: 300,
  pendingComponent: UserProfileSkeleton,
  component: LiveBroadcasterProfilePage,
});
